const ShipmentOverviewSkeleton = () => {
  return (
    <div className="col-12 col-xl-3">
      {/* Shipment Overview Skeleton */}
      <div
        className="card shadow-lg border-0"
        style={{
          borderRadius: "0.75rem",
          overflow: "hidden",
        }}
      >
        {/* Header Skeleton */}
        <div
          className="card-header d-flex align-items-center justify-content-between"
          style={{
            background: "linear-gradient(135deg, #00b4d8)",
            borderBottom: "none",
          }}
        >
          <div
            className="bg-light rounded"
            style={{ width: "150px", height: "24px", opacity: 0.3 }}
          />
          <div
            className="bg-light rounded"
            style={{ width: "32px", height: "32px", opacity: 0.3 }}
          />
        </div>

        {/* Body Skeleton */}
        <div className="card-body">
          {/* Route Skeleton */}
          <div className="mb-4">
            <div
              className="bg-secondary rounded mb-2"
              style={{ width: "60px", height: "12px", opacity: 0.3 }}
            />
            <div
              className="bg-secondary rounded"
              style={{ width: "100%", height: "28px", opacity: 0.3 }}
            />
          </div>

          {/* Distance Info Skeleton */}
          <div className="mb-4">
            <div
              className="d-flex mb-3"
              style={{
                borderBottom: "1px dashed rgba(0,0,0,0.1)",
                paddingBottom: "0.5rem",
                gap: "30px",
              }}
            >
              <div>
                <div
                  className="bg-secondary rounded mb-2"
                  style={{ width: "120px", height: "12px", opacity: 0.3 }}
                />
                <div
                  className="bg-secondary rounded"
                  style={{ width: "80px", height: "32px", opacity: 0.3 }}
                />
              </div>
              <div>
                <div
                  className="bg-secondary rounded mb-2"
                  style={{ width: "100px", height: "12px", opacity: 0.3 }}
                />
                <div
                  className="bg-secondary rounded"
                  style={{ width: "80px", height: "32px", opacity: 0.3 }}
                />
              </div>
            </div>

            {/* ETA Skeleton */}
            <div className="d-flex" style={{ gap: "20px" }}>
              <div>
                <div
                  className="bg-secondary rounded mb-2"
                  style={{ width: "40px", height: "12px", opacity: 0.3 }}
                />
                <div
                  className="bg-secondary rounded"
                  style={{ width: "70px", height: "32px", opacity: 0.3 }}
                />
              </div>
              <div>
                <div
                  className="bg-secondary rounded mb-2"
                  style={{ width: "40px", height: "12px", opacity: 0.3 }}
                />
                <div
                  className="bg-secondary rounded"
                  style={{ width: "70px", height: "32px", opacity: 0.3 }}
                />
              </div>
            </div>
          </div>

          {/* Button Skeleton */}
          <div className="mt-5">
            <div
              className="bg-secondary rounded"
              style={{ width: "100%", height: "40px", opacity: 0.2 }}
            />
          </div>
        </div>
      </div>

      {/* Vehicle Details Skeleton */}
      <div
        className="card shadow-lg border-0 mt-4"
        style={{
          borderRadius: "0.75rem",
          overflow: "hidden",
        }}
      >
        {/* Header Skeleton */}
        <div
          className="card-header"
          style={{
            background: "linear-gradient(135deg, #00b4d8)",
            borderBottom: "none",
          }}
        >
          <div
            className="bg-light rounded"
            style={{ width: "140px", height: "24px", opacity: 0.3 }}
          />
        </div>

        {/* Body Skeleton */}
        <div className="card-body">
          {/* Carrier + Truck Type Skeleton */}
          <div className="row mb-3">
            <div className="col">
              <div
                className="bg-secondary rounded mb-2"
                style={{ width: "60px", height: "12px", opacity: 0.3 }}
              />
              <div
                className="bg-secondary rounded"
                style={{ width: "100px", height: "24px", opacity: 0.3 }}
              />
            </div>
            <div className="col">
              <div
                className="bg-secondary rounded mb-2"
                style={{ width: "80px", height: "12px", opacity: 0.3 }}
              />
              <div
                className="bg-secondary rounded"
                style={{ width: "90px", height: "24px", opacity: 0.3 }}
              />
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px dashed #dee2e6",
              margin: "0.75rem 0",
            }}
          />

          {/* Details List Skeleton */}
          <ul className="list-unstyled mb-0 mt-3">
            <li className="mb-2">
              <div
                className="bg-secondary rounded"
                style={{ width: "180px", height: "16px", opacity: 0.3 }}
              />
            </li>
            <li className="mb-2">
              <div
                className="bg-secondary rounded"
                style={{ width: "160px", height: "16px", opacity: 0.3 }}
              />
            </li>
            <li className="mb-2">
              <div
                className="bg-secondary rounded"
                style={{ width: "200px", height: "16px", opacity: 0.3 }}
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ShipmentOverviewSkeleton;
